"use client";
import React from "react";
import CredHomeHero from "@/components/Cred/Home/Hero/Index";
import CredProvider from "../CredProvider";
import CredHowTo from "./HowTo/Page";
import CredHomeSummary from "./Summary/Page";
import CredHomeBoards from "./Boards/Page";

export default function CredHomePage() {
  return (
    <CredProvider>
      <CredHomeHero />
      <CredHowTo />
      <CredHomeBoards />
      <CredHomeSummary />
    </CredProvider>
  );
}
